<template>
  <div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 思政教育工作室名称
        </div>
        <div class="pl16">
          <a-input
            class="input-style-2"
            type="text"
            placeholder="请输入思政教育工作室名称"
            :maxLength="100"
            v-model="info.name"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
          />
        </div>
      </div>
    </div>
   
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 工作室地址
        </div>
        <div class="pl16">
          <a-input
            class="input-style-2"
            type="text"
            :maxLength="50"
            placeholder="请输入工作室地址"
            v-model="info.address"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
          />
        </div>
      </div>
    </div>
     <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 工作室创建时间
        </div>
        <div class="pl16">
            <a-date-picker     placeholder="请选择工作室创建时间"  v-model="info.foundTime"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'" :format="'YYYY-MM-DD'" :locale="locale"  />
        </div>
      </div>
    </div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 申报年份
        </div>
        <div class="pl16">
           <a-date-picker     placeholder="请选择申报年份"  v-model="info.applyYear"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'" :open='yearShowOne'   :locale="locale"  :format="'YYYY'"  mode="year"   @openChange="openChangeOne"
                @panelChange="panelChangeOne"/>
        </div>
      </div>
    </div>
    <!--<div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 联系电话
        </div>
        <div class="pl16">
          <a-input
            class="input-style-2"
            type="text"
            :maxLength="11"
            onkeyup="value=value.replace(/[^\d]/g,'')"
            placeholder="请输入联系电话"
            v-model="info.phone"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
          />
        </div>
      </div>
    </div>-->
   <div class="mt30">
    	 <div class="text1">申报书模板下载</div>
			      <div class="flex align-items-center">
			        <img class="img-box-4" src="../../assets/images/img39.png" alt="" />
			        <div class="text2" style="color: #2155B5; cursor: pointer">
			          <a
			            href="/思政教育工作室项目申报书.docx"
			            download="思政微课项目申报书.docx"
			            style="color: #2155B5"
			          >
			            思政教育工作室申报书.docx</a
			          >
			          <span class="text2">(32.2KB)</span>
			        </div>
			      </div>
        </div>
         <div class="mb15"  >
      <div class="flex align-items-center mb15">
        <img class="img-box-2" src="../../assets/images/img27.png" alt="" />
        <div class="text1">
        		  申报书上传
          <span
            style="color: #f6350f"
            >*</span
          >
        </div>
      </div>
      <div>
        <a-upload
          :file-list="fileList"
      	  :remove="(file, fileList) => handleRemove(file, fileList)"
          :before-upload="
            (file, fileList) => beforeUpload(file, fileList)
          "
           accept=".pdf"
          
        >
          <a-button
            :disabled="
              ($parent.editInfo && $parent.editInfo.type == 'preview') ||
              loading
            "
            :loading="loading"
          >
            <a-icon type="upload" /> 上传附件
          </a-button>
          <span class="text2"> 注：请上传pdf格式的文件</span>
        </a-upload>
      </div>
    </div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 面积
        </div>
        <div class="pl16 plflex">
           <a-input  class="input-style-2"
            type="text"    pattern="[1-9]\d*"  placeholder="请输入思政教育工作室面积"  v-model="info.acreage" style="width:50%;" :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"/>
           <span class="text2">平方米</span>
        </div>
      </div>
    </div>
    <div class="mt30">
      <div>
        <div class="main-text-style">
          <span style="color: #f6350f">*</span> 所属部门
        </div>
        <div class="pl16">
          <a-input
            class="input-style-2"
            type="text"
            placeholder="请输入思政教育工作室所属部门"
            :maxLength="100"
            v-model="info.belongDepartment"
            :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
          />
      </div>
    </div>
       <div class="submit-btn" @click="goStep">下 一 步</div>
    </div>
  </div>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import { postAction, putAction,fileUpdate} from "@/api/index";
import { baseURL } from "@/utils/request.js";
export default {
  name: "",
  components: {},
  props: {
    oldInfos: {
      type: Object,
    },
  },
  data() {
    return {
      info: {
      	applyType:'1',
        name: "",
        address: "",
        foundTime: "",
        applyYear:'',
        id:'',
        declarationName:'',
        declarationPath:'',
        acreage:'',
        belongDepartment:'',
      },
      zh_CN,
      locale,
      yearShowOne: false,
      path: baseURL,
      fileList:[],
      loading:false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  destroyed(){
    sessionStorage.setItem(
      `step${this.$store.state.user.id}`,
      JSON.stringify(this.info)
    );
  },
  mounted() {
    let oldInfo = JSON.parse(
      sessionStorage.getItem(`step${this.$store.state.user.id}`)
    );
    if (oldInfo) {
    	this.info.id= oldInfo.id;
      this.info.name = oldInfo.name;
      this.info.address = oldInfo.address;
      this.info.foundTime = oldInfo.foundTime;
      this.info.applyYear = oldInfo.applyYear;
      this.info.declarationName=oldInfo.declarationName;
      this.info.declarationPath=oldInfo.declarationPath;
       this.info.acreage=oldInfo.acreage;
         this.info.belongDepartment=oldInfo.belongDepartment;
    }
    this.fileList=[];
    console.log(oldInfo);
    if(oldInfo && oldInfo.declarationName!='' && oldInfo.declarationName!=null && oldInfo.declarationPath!='' && oldInfo.declarationPath!=null){
    	 let fileItem = {};
          fileItem.path = oldInfo.declarationPath;
          fileItem.name = oldInfo.declarationName;
           fileItem.uid=1;
    	    this.fileList.push(fileItem);
//  	console.log(this.fileList);
    }
    if(this.oldInfos && this.oldInfos.declarationName!='' && this.oldInfos.declarationName!=null && this.oldInfos.declarationPath!='' && this.oldInfos.declarationPath!=null){
    	 this.fileList=[];
    	let fileItem = {};
          fileItem.path = this.oldInfos.declarationPath;
          fileItem.name = this.oldInfos.declarationName;
           fileItem.uid=1;
    	this.fileList.push(fileItem);
//  	console.log(this.fileList);
    }
  },
  methods: {
  	openChangeOne(status) {
            if (status){
                this.yearShowOne =  true
            }
    },
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file, fileList) {
      this.handleUpload(file);
      return false;
    },
    handleUpload(file) {
     
        if (this.fileList.length >= 1) {
          this.$message.error("申报书只能上传一个文件,请移除后再上传");
          return;
        }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList.push(fileItem);
          this.loading = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },
     // 得到年份选择器的值
    panelChangeOne(value) {
//   	      console.log(value,"111111");
            this.info.applyYear = value;
            this.yearShowOne = false;
    },
    goStep() {
      if (
        (this.info && this.info.name == "") ||
        this.info.name == undefined
      ) {
        this.$message.info("请填写项目名称");
        return false;
      } else if (
        (this.info && this.info.address === "") ||
        this.info.address == undefined
      ) {
        this.$message.info("请填写工作室地址");
        return false;
      }
      console.log(this.info.foundTime);
      if (
        (this.info && this.info.foundTime === "") ||
        this.info.foundTime == undefined
      ) {
        this.$message.info("请选择工作室创建时间");
        return false;
      } 
//    else {
//      var telStr = /^[1]([3-9])[0-9]{9}$/;
//      if (!telStr.test(this.info.phone)) {
//        this.$message.info("请输入正确格式手机号");
//        return false;
//      }
//    }
			if (
        (this.info && this.info.applyYear === "") ||
        this.info.applyYear == undefined
      ) {
        this.$message.info("请选择申报年份");
        return false;
      } 
      if ( this.fileList.length == 0
      ) {
        this.$message.info("请上传申报书");
        return false;
      } 
      if ((this.info && this.info.acreage === "") ||
        this.info.acreage == undefined
      ) {
        this.$message.info("请填写思政教育工作室面积");
        return false;
      }else{
      	let telStr = /^(0*[1-9]\d*\.?\d+|[1-9]\d*)$/;
      	if(!telStr.test(this.info.acreage)){
      		this.$message.info("输入的思政教育工作室面积格式不正确");
           return false;
      	}
      }
      if (  (this.info && this.info.belongDepartment === "") ||
        this.info.belongDepartment == undefined
      ) {
        this.$message.info("请填写思政教育工作室所属部门");
        return false;
      } 
      	const dateObj = new Date(this.info.foundTime);
				const year = dateObj.getFullYear();
				const month = dateObj.getMonth() + 1; // 月份是从 0 开始的，所以要加 1
				const date = dateObj.getDate();
				const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${date.toString().padStart(2, '0')}`;
				
       let params={
       	  applyType:this.info.applyType,
       	  name:this.info.name,
       	  address:this.info.address,
       	  foundTime:formattedDate,
       	  applyYear:new Date(this.info.applyYear).getFullYear()+"",
       	  id:this.info.id,
       	  declarationName:this.fileList[0].name,
       	  declarationPath:this.fileList[0].path,
       	  acreage:this.info.acreage,
       	  belongDepartment:this.info.belongDepartment,
       }
       this.info.declarationName=this.fileList[0].name;
       this.info.declarationPath=this.fileList[0].path;
//     console.log(params);
        postAction("/lx/lxApply/szAdd", params).then((res) => {
            if (res.code == 200) {
//              this.visible = false;
//              this.$message.success("添加成功");
								this.info.id=res.result.id;
								console.log(this.info);
                this.$emit("goStep", this.info);
            }else{
                this.$message.error(res.message);
            }
       });
    },
  },
};
</script>

<style scoped lang="scss">
.mt30 {
  margin-top: 20px;
}
.main-text-style {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 15px;
}
.input-style-2 {
  width: 100%;
  padding: 6px 12px;
  height: 40px;
  font-size: 14px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
/deep/ .ant-calendar-picker{
	width: 50%;
}
/deep/ .ant-input{
	width: 100%;
  padding: 6px 12px;
  height: 40px;
  font-size: 14px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.plflex{
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  margin-top: 50px;
  line-height: 38px;
  text-align: center;
  background: #2155B5;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.text1 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin-bottom: 15px;
}
.mb15-item{
  border-bottom: 1px solid #e4e0e0;
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin: 14px 0 15px 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.file-input-box {
  color: #2155B5;
}
.file {
  position: relative;
  width: 156px;
  height: 40px;
  background: #fff;
  border: 1px solid #2155B5;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #575757;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-bottom: 15px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: rgba(218, 218, 218, 0.2);
  color: #000;
  text-decoration: none;
}
</style>
